import React from 'react';
import { Text } from 'pcln-design-system';
import styled from 'styled-components';
const StyledPinLabel = /*#__PURE__*/styled(Text).withConfig({
  displayName: "SinglePinLabel__StyledPinLabel",
  componentId: "sc-1xxf5ir-0"
})(["text-shadow:-1px -1px 0 #ffffff,1px -1px 0 #ffffff,-1px 1px 0 #ffffff,1px 1px 0 #ffffff;"]);
export const SinglePinLabel = props => {
  const {
    name
  } = props;
  return React.createElement(StyledPinLabel, {
    bold: true,
    ml: 2,
    color: 'primary.base',
    size: 1
  }, name);
};